import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { ElectricCarsPageStoryContent } from '../lib/types/electric-cars-page'

import {
  traceFunction,
  tagError,
  getTraceId,
  setTag,
} from '@core/datadog-server'

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const ddMeta = {
    traceId: getTraceId(),
    traceTime: Date.now(),
  }
  try {
    const story = await getStoryBySlug<ElectricCarsPageStoryContent>(
      'electric-cars',
      {
        version: preview ? 'draft' : 'published',
      },
    )

    if (!story) {
      throw new Error('Electric car Story not found')
    }
    const HeroProps = story.content?.evHero?.[0]

    setTag('response.code', 200)

    return {
      props: {
        ddMeta,
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
        },
      },
      revalidate: 300, // In seconds
    }
  } catch (error) {
    console.error(error)

    if (typeof error === 'string' || error instanceof Error) {
      tagError(error)
    }

    return {
      notFound: true,
      props: {
        ddMeta,
      },
      revalidate: 30,
    }
  }
}

export type ElectricCarsProps = InferGetStaticPropsType<typeof getStaticProps>

export const getStaticProps = traceFunction(
  'electric-cars.getStaticProps',
  getStaticPropsfn,
)
